export interface IWeblog {
  init(log?: LogDataType): void;
  pageView(log?: LogDataType): void;
  click(log?: LogDataType): void;
  impression(log: LogDataType, key: string | number): void;
  search(log?: LogDataType): void;
  performance(log?: LogDataType): void;
  track(eventType: string, log?: LogDataType, key?: string | number): void;
  updateEventBind(): void;
  setDebugMode(active?: boolean): void;
  setExecMode(mode: EXEC_MODE): void;
  isWebViewMode(): boolean;
}

export enum TrackEventType {
  INIT = "init",
  PAGE_VIEW = "pageview",
  CLICK = "click",
  IMPRESSION = "impression",
  SEARCH = "search",
  PERFORMANCE = "performance",
}
export enum EXEC_MODE {
  WEBVIEW = "WEBVIEW",
  WEB = "WEB",
}

export type LogDataType = Record<string, any>;

export type LogQueueType = {
  eventType: string;
  log?: LogDataType;
  key?: string | number;
};

declare global {
  interface Window {
    MRT_WEBLOG: IWeblog;
    MRT_WEBLOG_QUEUE: LogQueueType[];
    MRT_WEBLOG_EXEC_MODE: EXEC_MODE;
  }
}

function _findInstance() {
  const { MRT_WEBLOG } = window;

  return MRT_WEBLOG || null;
}

function _enqueueLog(data: LogQueueType) {
  if (!window.MRT_WEBLOG_QUEUE || !window.MRT_WEBLOG_QUEUE.length) {
    window.MRT_WEBLOG_QUEUE = [];
  }

  window.MRT_WEBLOG_QUEUE.push(data);
}

function _handleTrack(
  eventType: string,
  log?: LogDataType,
  key?: string | number
) {
  const instance = _findInstance();

  if (!instance) {
    _enqueueLog({ eventType, log, key });

    return;
  }

  void instance.track(eventType, log, key);
}

export function sendInitLog(log?: LogDataType) {
  _handleTrack(TrackEventType.INIT, log);
}

export function sendPageViewLog(log: LogDataType) {
  _handleTrack(TrackEventType.PAGE_VIEW, log);
}

export function sendClickLog(log: LogDataType) {
  _handleTrack(TrackEventType.CLICK, log);
}

export function sendImpressionLog(log: LogDataType, key: string | number) {
  if (!key) {
    return;
  }
  _handleTrack(TrackEventType.IMPRESSION, log, key);
}

export function sendSearchLog(log: LogDataType) {
  _handleTrack(TrackEventType.SEARCH, log);
}

export function sendPerformanceLog(log: LogDataType) {
  _handleTrack(TrackEventType.PERFORMANCE, log);
}

export function trackLog(
  eventType: string,
  log?: LogDataType,
  key?: string | number
) {
  _handleTrack(eventType, log, key);
}
